export default __webpack_public_path__ + "static/media/Savitar.122f90f5.png";